// formC_SeguimientoObra.jsx
//NOTA: hacer prueba con la tabla de mediciones como componente hijo
import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import InfoButtonWithPopover from "./InfoButtonWithPopover";
import TablaMediciones from './TablaMediciones';
import TablaMejorasEtapaI from './TablaMejorasEtapaI';
import PagosFormulario from './PagosFormulario';
import CircuitoAdministrativo from './CircuitoAdministrativo';
import Modal2 from './Modal2';
import EncuestaSocioambiental from './EncuestaSocioambiental';
import NoObjecionPDF from './NoObjecionPDF';
import WKT from 'ol/format/WKT';
import GeoJSON from 'ol/format/GeoJSON';


import { useFormContext } from "../context/FormContext";
import { AuthContext } from "../context/authContext";
import { Input, Label, Button, Select_simple } from "../components/ui";
//import { optionsEncargadoRendicion, optionsOrganismoEncargado } from '../datos/options';
import { optionsEncargadoSeguimiento, optionsEncargadoSeguimientoMejoras } from "../datos/options";



// Opciones de porcentaje para los pagos
const OPCIONES_PORCENTAJE = {
    ANTICIPO: [
        { value: '30', label: '30%' },
        { value: '50', label: '50%' },
        { value: '100', label: '100%' }
    ],
    SEGUNDO_PAGO_50: [  // Opción para cuando el anticipo es 50%
        { value: '50', label: '50%' }
    ],
    SEGUNDO_PAGO_30: [  // Opción para cuando el anticipo es 30%
        { value: '35', label: '35%' }
    ],
    TERCER_PAGO: [  // Solo se usa cuando el anticipo es 30%
        { value: '35', label: '35%' }
    ],
    ADENDA: [  // Opción para pagos de adenda
        { value: '100', label: '100%' }
    ]
};

const esNuevoBeneficiario = (b) => b && b._isNew === true;

const FormC_SeguimientoObra = () => {
    const { formA, formC, updateField, loadField, updateFormC, updateFormData, markSectionDirty } = useFormContext();
    const { datosGenerales = {}, array_obras_expediente = [] } = formA;
    const { seguimientoObra = {}, arrayPagosMejoras = [], arrayPagosMicrocreditos = [], arrayPagosProyectos = [], arrayPagosIntervencionSocial = [], porcentaje_parcial_2do_pago: context_2do, porcentaje_parcial_3er_pago: context_3er } = formC || {};

    // Contador de renders para debugging
    const renderCount = useRef(0);
    renderCount.current++;
    const pago2do = arrayPagosProyectos?.find(p => p.tipo_pago === '2do_pago');
    console.log(`RENDER #${renderCount.current} - 2do pago monto:`, pago2do?.monto, 'porc_pago:', pago2do?.porc_pago);

    // Verificar permisos de usuario
    const { user, token, role } = useContext(AuthContext);
    const puedeVerMedicionesYProyectos = user === 'Javier' || user === 'pineroceli@gmail.com';

    // Obtener valores directamente del contexto
    const {
        //encargadoRendicion,
        encargadoSeguimiento,
        //organismoEncargado,
        //empresaContratista,
        fechaInicioObra,
        fechaFinObra,
        observaciones,

    } = seguimientoObra;

    // Estado local para mediciones de obra - ahora gestionado via TablaMediciones componente
    const [arrayMediciones, setArrayMediciones] = useState(() => {
        // Inicializar desde el contexto si existe
        return formC?.arrayMediciones || [];
    });

    // Estado local para seguimiento de Mejoras Etapa I - gestionado via TablaMejorasEtapaI
    const [arrayMejorasEtapaI, setArrayMejorasEtapaI] = useState(() => {
        return formC?.arrayMejorasEtapaI || [];
    });

    const [arrayMejorasEtapaII, setArrayMejorasEtapaII] = useState(() => {
        return formC?.arrayMejorasEtapaII || [];
    });

    const arrayCircuitoAdmin = formC?.arrayCircuitoAdmin || [];

    // Estado local para capturar porcentaje parcial cuando se habilita el 2do pago
    const [porcentajeParcial2doPago, setPorcentajeParcial2doPago] = useState(() => {
        return formC?.porcentaje_parcial_2do_pago || null;
    });

    // Efecto para sincronizar porcentajeParcial2doPago desde el contexto (al cargar datos guardados)
    useEffect(() => {
        const contextValue = formC?.porcentaje_parcial_2do_pago;
        if (contextValue !== undefined && contextValue !== null && contextValue !== porcentajeParcial2doPago) {
            setPorcentajeParcial2doPago(contextValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formC?.porcentaje_parcial_2do_pago]);

    // Estado local para capturar porcentaje parcial cuando se habilita el 3er pago
    const [porcentajeParcial3erPago, setPorcentajeParcial3erPago] = useState(() => {
        return formC?.porcentaje_parcial_3er_pago || null;
    });

    // Efecto para sincronizar porcentajeParcial3erPago desde el contexto (al cargar datos guardados)
    useEffect(() => {
        const contextValue = formC?.porcentaje_parcial_3er_pago;
        if (contextValue !== undefined && contextValue !== null && contextValue !== porcentajeParcial3erPago) {
            setPorcentajeParcial3erPago(contextValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formC?.porcentaje_parcial_3er_pago]);

    //console.log("LEON seguimientoObra", seguimientoObra)

    //// 1. Usar estado local para manejar los pagos mejoras
    // Para mejoras, no usamos estado local, editamos directamente en contexto
    // const [arrayPagosMejorasLocal, setArrayPagosMejorasLocal] = useState(() => {
    //     const initialData = formC?.arrayPagosMejoras;
    //     //console.log("GATO initialData ", initialData)
    //     return Array.isArray(initialData) && initialData.length > 0
    //         ? initialData
    //         : [
    //             { tipo_pago: "total", monto: '', fecha_pago: null, nro_instruccion: '', fecha_certificacion: null },
    //             { tipo_pago: "adenda", total_adenda: '', monto: '', fecha_pago: null, nro_instruccion: '', fecha_certificacion: null }
    //         ];
    // });

    // Para microcreditos, no usamos estado local, editamos directamente en contexto
    // const [arrayPagosMicrocreditosLocal, setArrayPagosMicrocreditosLocal] = useState(() => {
    //     const initialData = formC?.arrayPagosMicrocreditos;
    //     return Array.isArray(initialData) && initialData.length > 0
    //         ? initialData
    //         : [...PAGO_MICROCREDITOS_INICIAL];
    // });

    // Para proyectos, no usamos estado local, editamos directamente en contexto

    // Funciones de actualización que actualizan el contexto
    /*
    const setEncargadoRendicionValue = (value) => {
        updateField('formC', 'seguimientoObra', 'encargadoRendicion', value);
    };

    const setOrganismoEncargadoValue = (value) => {
        updateField('formC', 'seguimientoObra', 'organismoEncargado', value);
    };
    */
    //crear set para encargado de seguimiento
    const setEncargadoSeguimientoValue = (value) => {
        updateField('formC', 'seguimientoObra', 'encargadoSeguimiento', value);
    };

    const setEmpresaContratistaValue = (value) => {
        updateField('formC', 'seguimientoObra', 'empresaContratista', value);
    };

    const setFechaInicioObraValue = (value) => {
        updateField('formC', 'seguimientoObra', 'fechaInicioObra', value);
    };

    const setFechaFinObraValue = (value) => {
        updateField('formC', 'seguimientoObra', 'fechaFinObra', value);
    };

    const setObservacionesValue = (value) => {
        updateField('formC', 'seguimientoObra', 'observaciones', value);
        setTextInput1(value); // Actualizar el estado local para el contador de caracteres
    };

    // Usar los valores del contexto para los arrays de pagos, con valor por defecto de array vacío
    const arrayPagosMejorasValue = arrayPagosMejoras ?? [];
    const arrayPagosMicrocreditosValue = arrayPagosMicrocreditos ?? [];

    const areaResponsable = datosGenerales.area_responsable;
    // Área de Mejoras usa solo sus dos encargados; el resto, la lista completa.
    const opcionesEncargadoSeguimiento = areaResponsable === 'ÁREA DE MEJORAS'
        ? optionsEncargadoSeguimientoMejoras
        : optionsEncargadoSeguimiento;

    // Estado local para el monto de la adenda
    const [totalAdenda, setTotalAdenda] = useState(0);

    //ESTADOS LOCAL - para contador de caracteres
    const [textInput1, setTextInput1] = useState(''); //input observ_seguimiento_obra

    // Efecto para actualizar el monto de la adenda cuando cambia array_obras_expediente
    useEffect(() => {
        const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
        const suma = adendas.reduce((sum, exp) => sum + Number(exp.monto_adenda || 0), 0);
        setTotalAdenda(suma);
    }, [array_obras_expediente]);


    //dentro de arrayPagosMejoras, buscar el objeto con tipo_pago = 'adenda' y actualizar el valor de total_adenda con el valor de totalAdenda
    /*useEffect(() => {
        // Convierte totalAdenda a número (maneja strings numéricos)
        const numericTotalAdenda = Number(totalAdenda);

        // Solo actualizar si es un número válido (evita NaN o valores no numéricos)
        if (isNaN(numericTotalAdenda)) return;

        console.log("typeof totalAdenda original", typeof totalAdenda);
        console.log("numericTotalAdenda", numericTotalAdenda);
        if(areaResponsable === "ÁREA DE PROYECTOS"){
            const updatedArray = arrayPagosProyectosValue.map((pago, index) => {
                // Si el pago es de tipo 'adenda', actualiza total_adenda; de lo contrario, déjalo igual
                if (pago.tipo_pago === 'adenda') {
                    return { ...pago, total_adenda: totalAdenda };  // Crea un nuevo objeto (inmutabilidad)
                }
                return pago;  // Mantén el resto igual
            });

            //setArrayPagosProyectos(updatedArray);
            updateField("seguimientoObra", "arrayPagosProyectos", updatedArray);
        } else if(areaResponsable === "ÁREA DE MEJORAS"){
            const updatedArray = arrayPagosMejorasValue.map((pago, index) => {
                // Si el pago es de tipo 'adenda', actualiza total_adenda; de lo contrario, déjalo igual
                if (pago.tipo_pago === 'adenda') {
                    return { ...pago, total_adenda: totalAdenda };  // Crea un nuevo objeto (inmutabilidad)
                }
                return pago;  // Mantén el resto igual
            });
            
            updateField("seguimientoObra", "arrayPagosMejoras", updatedArray);
        } else if(areaResponsable === "ÁREA DE MICROCREDITOS"){
            const updatedArray = arrayPagosMicrocreditosValue.map((pago, index) => {
                // Si el pago es de tipo 'adenda', actualiza total_adenda; de lo contrario, déjalo igual
                if (pago.tipo_pago === 'adenda') {
                    return { ...pago, total_adenda: totalAdenda };  // Crea un nuevo objeto (inmutabilidad)
                }
                return pago;  // Mantén el resto igual
            });
            
            updateField("seguimientoObra", "arrayPagosMicrocreditos", updatedArray);
        }
    }, [totalAdenda]);
    */


    // Efecto para sincronizar monto_obra de datosGenerales con montoObra de seguimientoObra
    // Usa loadField para no marcar dirtySections durante carga inicial de edición
    useEffect(() => {
        if (datosGenerales.monto_obra !== undefined &&
            datosGenerales.monto_obra !== seguimientoObra.montoObra) {
            loadField('formC', 'seguimientoObra', 'montoObra', datosGenerales.monto_obra);
        }
    }, [datosGenerales.monto_obra, seguimientoObra.montoObra, loadField]);

    // Efecto para sincronizar arrayMediciones DESDE el contexto al estado local (cuando se carga desde BD)
    useEffect(() => {
        const contextMediciones = formC?.arrayMediciones;
        if (Array.isArray(contextMediciones)) {
            // Solo actualizar si los datos del contexto son diferentes a los locales
            const contextIds = contextMediciones.map(m => m.nro_medicion).join(',');
            const localIds = arrayMediciones.map(m => m.nro_medicion).join(',');
            if (contextIds !== localIds) {
                setArrayMediciones(contextMediciones);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formC?.arrayMediciones]);

    // Efecto para sincronizar arrayMediciones con el contexto (solo cuando cambia el estado local)
    // Usar loadField para NO marcar dirtySections (la marca dirty la pone el handler de usuario)
    useEffect(() => {
        loadField('formC', 'arrayMediciones', null, arrayMediciones);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayMediciones]);

    // Efecto para sincronizar arrayMejorasEtapaI DESDE el contexto al estado local (cuando se carga desde BD)
    useEffect(() => {
        const contextMejoras = formC?.arrayMejorasEtapaI;
        if (Array.isArray(contextMejoras)) {
            // Sincronizar solo si la cantidad de registros difiere o si el estado local está vacío y el contexto tiene datos
            if (contextMejoras.length !== arrayMejorasEtapaI.length ||
                (arrayMejorasEtapaI.length === 0 && contextMejoras.length > 0)) {
                setArrayMejorasEtapaI(contextMejoras);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formC?.arrayMejorasEtapaI]);

    // Efecto para sincronizar arrayMejorasEtapaI con el contexto (solo cuando cambia el estado local)
    useEffect(() => {
        loadField('formC', 'arrayMejorasEtapaI', null, arrayMejorasEtapaI);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayMejorasEtapaI]);

    // Efecto para sincronizar arrayMejorasEtapaII DESDE el contexto al estado local
    useEffect(() => {
        const contextMejorasII = formC?.arrayMejorasEtapaII;
        if (Array.isArray(contextMejorasII)) {
            if (contextMejorasII.length !== arrayMejorasEtapaII.length ||
                (arrayMejorasEtapaII.length === 0 && contextMejorasII.length > 0)) {
                setArrayMejorasEtapaII(contextMejorasII);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formC?.arrayMejorasEtapaII]);

    // Efecto para sincronizar arrayMejorasEtapaII con el contexto
    useEffect(() => {
        loadField('formC', 'arrayMejorasEtapaII', null, arrayMejorasEtapaII);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayMejorasEtapaII]);


    // Efecto para capturar o limpiar porcentaje parcial del 2do pago (>= 25%)
    useEffect(() => {
        // Las mediciones se cargan ya acumuladas: el avance es el de la medición
        // más reciente (mayor nro_medicion), NO la suma de todas (lógica de la época parcial)
        const ultimaMedicion = arrayMediciones.reduce((acc, medicion) => (
            !acc || (parseInt(medicion?.nro_medicion, 10) || 0) >= (parseInt(acc?.nro_medicion, 10) || 0)
                ? medicion
                : acc
        ), null);
        const avanceAcumulado = parseFloat(ultimaMedicion?.porcentaje_avance) || 0;

        // Usar formC.arrayPagosProyectos directamente para obtener valor actual del contexto
        const pagosActuales = formC?.arrayPagosProyectos || [];

        // Verificar si los datos han sido cargados del servidor
        // Si no hay anticipo con porc_pago, los datos aún no cargaron o es una obra nueva
        const anticipoCargado = pagosActuales[0]?.porc_pago;
        if (!anticipoCargado && pagosActuales.length > 0) {
            console.log('DEBUG 2do PAGO: Datos aún no cargados del servidor, saltando...');
            return;
        }

        const index2doPago = pagosActuales.findIndex(p => p.tipo_pago === '2do_pago');
        const porcPagoActual = index2doPago >= 0 ? pagosActuales[index2doPago]?.porc_pago : null;

        // Obtener datos completos del 2do pago para debugging
        const pago2doDebug = index2doPago >= 0 ? pagosActuales[index2doPago] : null;
        console.log('=== DEBUG 2do PAGO ===', {
            avanceAcumulado,
            porcentajeParcial2doPago,
            porcPagoActual,
            index2doPago,
            pago2do: pago2doDebug,
            pagos: pagosActuales.map(p => ({ tipo: p.tipo_pago, porc: p.porc_pago, monto: p.monto, disabled: p.disabled }))
        });

        // Si hay valor capturado pero el avance bajó a < 25%, limpiar el histórico
        // Solo limpiar porc_pago y monto si el pago NO es efectivo (no tiene datos de BD)
        if (porcentajeParcial2doPago !== null && avanceAcumulado < 25) {
            const pago2do = index2doPago >= 0 ? pagosActuales[index2doPago] : null;
            // Si el pago es efectivo (viene de BD con datos), NO limpiar
            const esPagoEfectivo = pago2do?.esPagoEfectivo;
            if (esPagoEfectivo) {
                console.log('BAJANDO DE UMBRAL: Pago es efectivo, NO limpiando:', {
                    esPagoEfectivo: pago2do?.esPagoEfectivo,
                    porc_pago: pago2do?.porc_pago,
                    monto: pago2do?.monto
                });
            } else {
                console.log('BAJANDO DE UMBRAL: Limpiando histórico y pago (no es efectivo)');
                setPorcentajeParcial2doPago(null);
                updateField('formC', 'porcentaje_parcial_2do_pago', null, null);
                if (index2doPago >= 0 && !pago2do?.fecha_pago) {
                    console.log('Llamando handlePagoChangeProyectos para limpiar (no efectuado)');
                    handlePagoChangeProyectos(index2doPago, 'porc_pago', '');
                    handlePagoChangeProyectos(index2doPago, 'monto', '');
                }
            }
        }

        // Si NO hay valor capturado y el avance es >= 25%, capturar el histórico
        // Solo limpiar porc_pago y monto si el pago NO está configurado (sin porc_pago)
        if (!porcentajeParcial2doPago && avanceAcumulado >= 25) {
            console.log('SUBIENDO A UMBRAL: Capturando histórico');
            setPorcentajeParcial2doPago(avanceAcumulado);
            updateField('formC', 'porcentaje_parcial_2do_pago', null, avanceAcumulado);
            // Solo limpiar porc_pago y monto si el pago no está configurado (sin porc_pago)
            const pago2do = index2doPago >= 0 ? pagosActuales[index2doPago] : null;
            console.log('Index 2do pago:', index2doPago, 'tiene porc_pago:', pago2do?.porc_pago);
            if (index2doPago >= 0 && !pago2do?.porc_pago) {
                console.log('Llamando handlePagoChangeProyectos para limpiar (no configurado)');
                handlePagoChangeProyectos(index2doPago, 'porc_pago', '');
                handlePagoChangeProyectos(index2doPago, 'monto', '');
            }
        }

        // Si YA hay valor capturado, avance >= 25%, y pago está VACÍO → actualizar histórico
        // Esto permite que el histórico siga al avance actual mientras no haya datos de pago
        console.log('DEBUG HISTÓRICO 2do:', {
            porcentajeParcial2doPago,
            avanceAcumulado,
            condicionPrincipal: porcentajeParcial2doPago !== null && avanceAcumulado >= 25,
            index2doPago,
            pago2do: pagosActuales[index2doPago]
        });
        if (porcentajeParcial2doPago !== null && avanceAcumulado >= 25) {
            const pago2do = index2doPago >= 0 ? pagosActuales[index2doPago] : null;
            // Usar esPagoEfectivo para determinar si el pago es real (de la BD) o temporal (formulario)
            const esPagoEfectivo = pago2do?.esPagoEfectivo;
            console.log('DEBUG DENTRO IF:', { esPagoEfectivo, diferencia: avanceAcumulado !== porcentajeParcial2doPago });

            if (!esPagoEfectivo) {
                // Pago no efectivo: actualizar histórico al avance actual (puede subir o bajar, pero >= 25%)
                if (avanceAcumulado !== porcentajeParcial2doPago) {
                    console.log('ACTUALIZANDO HISTÓRICO: Pago no efectivo, ajustando de', porcentajeParcial2doPago, 'a', avanceAcumulado);
                    setPorcentajeParcial2doPago(avanceAcumulado);
                    updateField('formC', 'porcentaje_parcial_2do_pago', null, avanceAcumulado);
                } else {
                    console.log('HISTÓRICO: Sin cambios, valores iguales');
                }
            } else {
                console.log('HISTÓRICO BLOQUEADO: Pago es efectivo (de BD)', {
                    esPagoEfectivo: pago2do?.esPagoEfectivo,
                    porc_pago: pago2do?.porc_pago,
                    monto: pago2do?.monto
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayMediciones, formC?.arrayPagosProyectos]);

    // Efecto para capturar o limpiar porcentaje parcial del 3er pago (>= 60%)
    useEffect(() => {
        // Las mediciones se cargan ya acumuladas: el avance es el de la medición
        // más reciente (mayor nro_medicion), NO la suma de todas (lógica de la época parcial)
        const ultimaMedicion = arrayMediciones.reduce((acc, medicion) => (
            !acc || (parseInt(medicion?.nro_medicion, 10) || 0) >= (parseInt(acc?.nro_medicion, 10) || 0)
                ? medicion
                : acc
        ), null);
        const avanceAcumulado = parseFloat(ultimaMedicion?.porcentaje_avance) || 0;

        // Usar formC.arrayPagosProyectos directamente para obtener valor actual del contexto
        const pagosActuales = formC?.arrayPagosProyectos || [];

        // Verificar si los datos han sido cargados del servidor
        const anticipoCargado = pagosActuales[0]?.porc_pago;
        if (!anticipoCargado && pagosActuales.length > 0) {
            console.log('DEBUG 3er PAGO: Datos aún no cargados del servidor, saltando...');
            return;
        }

        const index3erPago = pagosActuales.findIndex(p => p.tipo_pago === '3er_pago');
        const porcPagoActual = index3erPago >= 0 ? pagosActuales[index3erPago]?.porc_pago : null;

        // Si hay valor capturado pero el avance bajó a < 60%, limpiar el histórico
        // Solo limpiar porc_pago y monto si el pago NO es efectivo (no tiene datos de BD)
        if (porcentajeParcial3erPago !== null && avanceAcumulado < 60) {
            const pago3er = index3erPago >= 0 ? pagosActuales[index3erPago] : null;
            // Si el pago es efectivo (viene de BD con datos), NO limpiar
            const esPagoEfectivo = pago3er?.esPagoEfectivo;
            if (esPagoEfectivo) {
                console.log('BAJANDO DE UMBRAL 3er: Pago es efectivo, NO limpiando:', {
                    esPagoEfectivo: pago3er?.esPagoEfectivo,
                    porc_pago: pago3er?.porc_pago,
                    monto: pago3er?.monto
                });
            } else {
                console.log('BAJANDO DE UMBRAL 3er: Limpiando histórico y pago (no es efectivo)');
                setPorcentajeParcial3erPago(null);
                updateField('formC', 'porcentaje_parcial_3er_pago', null, null);
                if (index3erPago >= 0 && !pago3er?.fecha_pago) {
                    handlePagoChangeProyectos(index3erPago, 'porc_pago', '');
                    handlePagoChangeProyectos(index3erPago, 'monto', '');
                }
            }
        }

        // Si NO hay valor capturado y el avance supera 60%, capturar el histórico
        // Solo capturar histórico si el pago NO es efectivo (no tiene datos de BD)
        if (!porcentajeParcial3erPago && avanceAcumulado >= 60) {
            const pago3er = index3erPago >= 0 ? pagosActuales[index3erPago] : null;
            // Si el pago ya es efectivo (viene de BD con datos), NO sobreescribir histórico
            const esPagoEfectivo = pago3er?.esPagoEfectivo;
            if (esPagoEfectivo) {
                console.log('SUBIENDO A UMBRAL 3er: Pago es efectivo, usando valor del contexto:', {
                    porcentaje_parcial_3er_pago: formC?.porcentaje_parcial_3er_pago
                });
                // Usar el valor del contexto en lugar del avance actual
                const valorHistorico = formC?.porcentaje_parcial_3er_pago || avanceAcumulado;
                setPorcentajeParcial3erPago(valorHistorico);
                updateField('formC', 'porcentaje_parcial_3er_pago', null, valorHistorico);
            } else {
                console.log('SUBIENDO A UMBRAL 3er: Capturando histórico nuevo:', avanceAcumulado);
                setPorcentajeParcial3erPago(avanceAcumulado);
                updateField('formC', 'porcentaje_parcial_3er_pago', null, avanceAcumulado);
                if (index3erPago >= 0 && !pago3er?.fecha_pago) {
                    handlePagoChangeProyectos(index3erPago, 'porc_pago', '');
                    handlePagoChangeProyectos(index3erPago, 'monto', '');
                }
            }
        }

        // Si YA hay valor capturado, avance >= 60%, y pago está VACÍO → actualizar histórico
        // Esto permite que el histórico siga al avance actual mientras no haya datos de pago
        if (porcentajeParcial3erPago !== null && avanceAcumulado >= 60) {
            const pago3er = index3erPago >= 0 ? pagosActuales[index3erPago] : null;
            // Usar esPagoEfectivo para determinar si el pago es real (de la BD) o temporal (formulario)
            const esPagoEfectivo = pago3er?.esPagoEfectivo;

            if (!esPagoEfectivo) {
                // Pago no efectivo: actualizar histórico al avance actual (puede subir o bajar, pero >= 60%)
                if (avanceAcumulado !== porcentajeParcial3erPago) {
                    console.log('ACTUALIZANDO HISTÓRICO 3er: Pago no efectivo, ajustando de', porcentajeParcial3erPago, 'a', avanceAcumulado);
                    setPorcentajeParcial3erPago(avanceAcumulado);
                    updateField('formC', 'porcentaje_parcial_3er_pago', null, avanceAcumulado);
                }
            } else {
                console.log('HISTÓRICO 3er BLOQUEADO: Pago es efectivo (de BD)', {
                    esPagoEfectivo: pago3er?.esPagoEfectivo,
                    porc_pago: pago3er?.porc_pago,
                    monto: pago3er?.monto
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayMediciones, formC?.arrayPagosProyectos]);

    // Efecto para recalcular disabled de pagos al cargar datos del servidor
    // Solo recalcula si los pagos cambian y NO es por cambio del usuario (evitar loops)
    useEffect(() => {
        const pagos = formC?.arrayPagosProyectos;
        if (!Array.isArray(pagos) || pagos.length === 0) return;

        // Verificar si algún pago tiene disabled incorrecto
        // Un pago con monto y porc_pago debería tener disabled=false
        let necesitaActualizar = false;
        const pagosActualizados = pagos.map((pago, index) => {
            if (!pago) return pago;

            // Si tiene monto y porc_pago, disabled debería ser false
            const tieneDatos = pago.monto && pago.monto !== '' && pago.monto !== '0' &&
                pago.porc_pago && pago.porc_pago !== '';

            if (tieneDatos && pago.disabled === true) {
                necesitaActualizar = true;
                console.log(`Corrigiendo disabled para ${pago.tipo_pago}: true -> false`);
                return { ...pago, disabled: false };
            }

            return pago;
        });

        if (necesitaActualizar) {
            console.log('Actualizando pagos con disabled corregido:', pagosActualizados);
            updateField('formC', 'arrayPagosProyectos', null, pagosActualizados);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formC?.arrayPagosProyectos]);

    //contador de caracteres #19NOV25:   
    const contadorCaracteresRestantes = (limite, texto) => {
        // Si el texto es null o undefined, usar string vacío
        const longitud = texto ? texto.length : 0;
        // Asegurarse de que el límite sea un número válido
        const limiteValido = limite || 0;
        // Calcular caracteres restantes, asegurando que no sea negativo
        return Math.max(0, limiteValido - longitud);
    }


    // Función para actualizar los estados de habilitación basados en el anticipo seleccionado
    const actualizarPorcentajes = (pagos) => {
        // Validar que pagos sea un array
        if (!Array.isArray(pagos)) return [];

        // Verificar que los valores sean números válidos
        const esNumeroValido = (valor) => !isNaN(parseFloat(valor)) && isFinite(valor);

        const anticipo = parseFloat(pagos[0]?.porc_pago || 0);
        const montoConveniado = parseFloat(datosGenerales.monto_obra || 0);

        console.log('DEBUG actualizarPorcentajes - anticipo:', anticipo, 'pagos[0]:', pagos[0]);

        // Obtener valores válidos de los pagos
        const segundoPagoValido = esNumeroValido(pagos[1]?.porc_pago) ? parseFloat(pagos[1].porc_pago) : 0;
        const tercerPagoValido = esNumeroValido(pagos[2]?.porc_pago) ? parseFloat(pagos[2].porc_pago) : 0;

        // Determinar si adenda debe estar habilitada
        const debeHabilitarAdenda = (
            (anticipo === 50 && segundoPagoValido === 50) ||
            (anticipo === 30 && (segundoPagoValido + tercerPagoValido) === 70)
        );

        // Depuración
        console.log('Estado de habilitación de adenda:', {
            anticipo,
            segundoPago: pagos[1]?.porc_pago,
            tercerPago: pagos[2]?.porc_pago,
            segundoPagoValido,
            tercerPagoValido,
            debeHabilitarAdenda
        });

        // Si no hay anticipo, deshabilitar todo excepto el primer pago
        if (!anticipo) {
            return pagos.map((pago, i) => pago ? {
                ...pago,
                disabled: i !== 0 || pago.tipo_pago === 'adenda',
                monto: '0',
                porc_pago: ''
            } : null).filter(Boolean);
        }

        // Función auxiliar para verificar si un pago está completo
        const pagoCompleto = (pago) => pago?.porc_pago && pago.porc_pago !== '';

        // Mapear pagos y actualizar estado
        return pagos.map((pago, i) => {
            // Si el pago no existe, retornar null (será filtrado)
            if (!pago) return null;

            // Manejar pago de adenda
            if (pago.tipo_pago === 'adenda') {
                return {
                    ...pago,
                    disabled: !debeHabilitarAdenda,
                    monto: debeHabilitarAdenda ? (pago.monto || '0') : '0',
                    porc_pago: debeHabilitarAdenda ? (pago.porc_pago || '') : ''
                };
            }

            // Lógica para pagos regulares
            if (anticipo === 50) {
                if (i === 0) { // Anticipo 50%
                    return {
                        ...pago,
                        disabled: false,
                        monto: (montoConveniado * 0.50).toFixed(2),
                        porc_pago: '50'
                    };
                }
                if (i === 1) { // Segundo pago 50%
                    return {
                        ...pago,
                        disabled: false,
                        monto: pago.porc_pago ? (montoConveniado * parseFloat(pago.porc_pago) / 100).toFixed(2) : '0',
                        porc_pago: pago.porc_pago || ''
                    };
                }
                // Tercer pago deshabilitado para anticipo 50%
                return {
                    ...pago,
                    disabled: true,
                    monto: '0',
                    porc_pago: ''
                };
            }

            if (anticipo === 30) {
                if (i === 0) { // Anticipo 30%
                    return {
                        ...pago,
                        disabled: false,
                        monto: (montoConveniado * 0.30).toFixed(2),
                        porc_pago: '30'
                    };
                }
                if (i === 1) { // Segundo pago
                    const montoCalculado = pago.porc_pago ? (montoConveniado * parseFloat(pago.porc_pago) / 100).toFixed(2) : '0';
                    console.log('DEBUG actualizarPorcentajes - 2do pago:', {
                        porc_pago: pago.porc_pago,
                        montoConveniado,
                        montoCalculado,
                        montoOriginal: pago.monto
                    });
                    return {
                        ...pago,
                        disabled: false,
                        monto: montoCalculado,
                        porc_pago: pago.porc_pago || ''
                    };
                }
                if (i === 2) { // Tercer pago
                    const segundoPagoCompleto = pagoCompleto(pagos[1]);
                    console.log('DEBUG 3er pago:', {
                        segundoPagoCompleto,
                        segundoPago: pagos[1],
                        pagoActual: pago,
                        montoResultado: segundoPagoCompleto ? (pago.monto || '0') : '0'
                    });
                    return {
                        ...pago,
                        disabled: !segundoPagoCompleto,
                        monto: segundoPagoCompleto ? (pago.monto || '0') : '0',
                        porc_pago: segundoPagoCompleto ? (pago.porc_pago || '') : ''
                    };
                }
            }

            return pago;
        }).filter(Boolean); // Filtramos cualquier null resultante
    };

    // Handler para proyectos, actualiza directamente el contexto
    const handlePagoChangeProyectos = (index, field, value) => {
        console.log("Actualizando pago proyectos:", { index, field, value });

        const currentArray = Array.isArray(formC.arrayPagosProyectos) ? [...formC.arrayPagosProyectos] : [];

        // Asegurarse de que el índice existe
        if (!currentArray[index]) {
            currentArray[index] = {};
        }

        // Crear un nuevo objeto de pago con el campo actualizado
        const updatedPago = {
            ...currentArray[index],
            [field]: value
        };

        // Si se está actualizando el porcentaje de pago
        if (field === 'porc_pago') {
            if (value === '' || isNaN(value)) {
                // Si se selecciona 'Seleccione' o valor inválido, limpiar el monto
                updatedPago.monto = '';
            } else {
                // Si es un pago de adenda, usar el monto de la adenda correspondiente, de lo contrario usar monto_obra
                const montoBase = currentArray[index]?.tipo_pago === 'adenda'
                    ? (() => {
                        const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                        const adendaIdx = currentArray.slice(0, index + 1).filter(p => p?.tipo_pago === 'adenda').length - 1;
                        return parseFloat(adendas[adendaIdx]?.monto_adenda || 0);
                    })()
                    : parseFloat(datosGenerales.monto_obra || 0);

                const porcentaje = parseFloat(value);
                // Calcular el monto basado en el porcentaje (hasta 2 decimales)
                const montoCalculado = (montoBase * porcentaje / 100).toFixed(2);
                updatedPago.monto = montoCalculado;
            }
        }

        currentArray[index] = updatedPago;

        // Si estamos cambiando el porcentaje del anticipo, actualizar los estados
        if (index === 0 && field === 'porc_pago') {
            const updatedArray = actualizarPorcentajes(currentArray);
            updateField('formC', 'arrayPagosProyectos', null, updatedArray);
            return;
        }

        // Si estamos deseleccionando el segundo pago (índice 1) y el anticipo es 30%,
        // también debemos limpiar el tercer pago (índice 2)
        if (index === 1 && field === 'porc_pago' && value === '' &&
            currentArray[0]?.porc_pago === '30' &&
            currentArray[2]) {
            currentArray[2] = {
                ...currentArray[2],
                monto: '0',
                porc_pago: ''
            };
        }

        updateField('formC', 'arrayPagosProyectos', null, currentArray);
    };

    // ============ FUNCIONES PARA TABLA DE MEDICIONES ============

    // Handler para cambios en mediciones desde TablaMediciones componente
    const handleMedicionesChange = useCallback((nuevasMediciones) => {
        setArrayMediciones(nuevasMediciones);
        markSectionDirty('formC_mediciones');
    }, [markSectionDirty]);

    // Handler para cambios en mejoras desde TablaMejorasEtapaI componente
    const handleMejorasEtapaIChange = useCallback((nuevosRegistros) => {
        setArrayMejorasEtapaI(nuevosRegistros);
        markSectionDirty('formC_mejoras');
    }, [markSectionDirty]);

    // Handler para cambios en mejoras desde TablaMejorasEtapaII componente
    const handleMejorasEtapaIIChange = useCallback((nuevosRegistros) => {
        setArrayMejorasEtapaII(nuevosRegistros);
        markSectionDirty('formC_mejoras');
    }, [markSectionDirty]);

    // Handler para cambios en circuito administrativo
    const handleCircuitoAdminChange = useCallback((nuevosRegistros) => {
        updateField('formC', 'arrayCircuitoAdmin', null, nuevosRegistros);
    }, [updateField]);

    const [beneficiarioEditando, setBeneficiarioEditando] = useState(null);
    const [beneficiarioPDF, setBeneficiarioPDF] = useState(null);
    const [beneficiarioGeoEditando, setBeneficiarioGeoEditando] = useState(null);
    const [beneficiarioEditandoModal, setBeneficiarioEditandoModal] = useState(null);
    const [modal2Abierto, setModal2Abierto] = useState(false);
    const [showBarrioColumns, setShowBarrioColumns] = useState(false);
    const [barrioFeatures, setBarrioFeatures] = useState([]);

    const circuitoAdminDisabled = datosGenerales.estado !== 'En circuito administrativo';
    const [circuitoAdminOpen, setCircuitoAdminOpen] = useState(!circuitoAdminDisabled);
    const [beneficiariosOpen, setBeneficiariosOpen] = useState(true);

    const checkGeom = (geom, coords) => {
        if (typeof geom.containsXY === 'function') return geom.containsXY(coords[0], coords[1]);
        if (geom.getPolygons) return geom.getPolygons().some(p => checkGeom(p, coords));
        return false;
    };

    useEffect(() => {
        if (!datosGenerales?.partido || datosGenerales.partido === 0) return;
        let cancelled = false;
        const fetchBarrios = async () => {
            try {
                const res = await fetch(`/api/barrios/todos_geom?partido=${datosGenerales.partido}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!res.ok || cancelled) return;
                const data = await res.json();
                if (data?.type !== 'FeatureCollection' || cancelled) return;
                const features = new GeoJSON().readFeatures(data, { featureProjection: 'EPSG:4326', dataProjection: 'EPSG:4326' });
                if (!cancelled) setBarrioFeatures(features.filter(f => f.getGeometry()));
            } catch (e) {
                console.warn('Error fetching barrio geometries:', e);
            }
        };
        fetchBarrios();
        return () => { cancelled = true; };
    }, [datosGenerales?.partido]);

    const beneficiarioBarrios = useMemo(() => {
        const wktFormat = new WKT();
        const result = new Map();
        const beneficiaries = Array.isArray(formA?.arrayBeneficiarios) ? formA.arrayBeneficiarios : [];
        if (barrioFeatures.length === 0) return result;
        beneficiaries.forEach((item) => {
            if (!item.wkt) return;
            try {
                const point = wktFormat.readGeometry(item.wkt, { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:4326' });
                const renabap = [];
                const rppvap = [];
                for (const bf of barrioFeatures) {
                    const geom = bf.getGeometry();
                    if (geom && checkGeom(geom, point.getCoordinates())) {
                        const tipo = bf.get('tipo');
                        if (tipo === 'RENABAP') renabap.push(bf.get('nombre'));
                        else if (tipo === 'RPPVAP') rppvap.push(bf.get('nombre'));
                    }
                }
                const esOtro = renabap.length === 0 && rppvap.length === 0;
                result.set(item.id, {
                    renabap: renabap.join(', ') || null,
                    rppvap: rppvap.join(', ') || null,
                    otro: esOtro ? (item.barrio || 'Otro') : null,
                });
            } catch (e) { }
        });
        return result;
    }, [formA?.arrayBeneficiarios, barrioFeatures]);

    const handleAgregarBeneficiario = useCallback(() => {
        setModal2Abierto(true);
    }, []);

    const handleEditarEncuesta = useCallback((item) => {
        setBeneficiarioEditandoModal(item);
        setModal2Abierto(true);
    }, []);

    const handleEditarGeo = useCallback((item) => {
        setBeneficiarioGeoEditando(item);
        setModal2Abierto(true);
    }, []);

    const handleCerrarModal2 = useCallback(() => {
        setBeneficiarioGeoEditando(null);
        setBeneficiarioEditandoModal(null);
        setModal2Abierto(false);
    }, []);

    const handleBeneficiariosChange = useCallback((nuevosBeneficiarios) => {
        const ordenados = [...nuevosBeneficiarios].sort((a, b) => a.id.localeCompare(b.id));
        updateField('formA', 'arrayBeneficiarios', null, ordenados);
    }, [updateField]);

    const handleAddTarget = useCallback((barrio) => {
        if (!barrio) return;
        if (barrio.tipo === 'RENABAP') {
            const current = formA?.barriosRENABAPSeleccionados || [];
            if (!current.some(b => String(b.value) === String(barrio.id))) {
                const nuevo = { value: String(barrio.id), label: `${barrio.nombre} (${barrio.id})` };
                updateFormData('formA', {
                    barriosRENABAPSeleccionados: [...current, nuevo],
                });
            }
        } else if (barrio.tipo === 'RPPVAP') {
            const current = formA?.barriosSeleccionados || [];
            if (!current.some(b => String(b.value) === String(barrio.id))) {
                const nuevo = { value: String(barrio.id), label: `${barrio.id} - ${barrio.nombre}` };
                updateFormData('formA', {
                    barriosSeleccionados: [...current, nuevo],
                });
            }
        }
    }, [formA?.barriosRENABAPSeleccionados, formA?.barriosSeleccionados, updateFormData]);

    const handleRemoveTarget = useCallback((barrio) => {
        if (!barrio) return;
        if (barrio.tipo === 'RENABAP') {
            const current = formA?.barriosRENABAPSeleccionados || [];
            updateFormData('formA', {
                barriosRENABAPSeleccionados: current.filter(b => String(b.value) !== String(barrio.id)),
            });
        } else if (barrio.tipo === 'RPPVAP') {
            const current = formA?.barriosSeleccionados || [];
            updateFormData('formA', {
                barriosSeleccionados: current.filter(b => String(b.value) !== String(barrio.id)),
            });
        }
    }, [formA?.barriosRENABAPSeleccionados, formA?.barriosSeleccionados, updateFormData]);

    const handleSetOtroTipo = useCallback(() => {
        const currentTipos = formA?.tiposBarrioSeleccionados || [];
        if (!currentTipos.some(t => t.value === 'OTRO')) {
            updateFormData('formA', {
                tiposBarrioSeleccionados: [...currentTipos, { value: 'OTRO', label: 'Otro' }],
            });
        }
    }, [formA?.tiposBarrioSeleccionados, updateFormData]);

    const handleRemoveOtroTipo = useCallback(() => {
        const currentTipos = formA?.tiposBarrioSeleccionados || [];
        if (currentTipos.some(t => t.value === 'OTRO')) {
            updateFormData('formA', {
                tiposBarrioSeleccionados: currentTipos.filter(t => t.value !== 'OTRO'),
            });
        }
    }, [formA?.tiposBarrioSeleccionados, updateFormData]);

    const handleSetOtroNombre = useCallback((nombre) => {
        if (!nombre) return;
        const current = formA?.barrioOtroNombres || [];
        if (!current.includes(nombre)) {
            updateField('formA', 'barrioOtroNombres', null, [...current, nombre]);
        }
    }, [formA?.barrioOtroNombres, updateField]);

    const handleEliminarBeneficiario = useCallback((id) => {
        const actualizados = (Array.isArray(formA?.arrayBeneficiarios) ? formA.arrayBeneficiarios : []).filter(b => b.id !== id);
        updateField('formA', 'arrayBeneficiarios', null, actualizados);
    }, [formA?.arrayBeneficiarios, updateField]);

    const mapToEncuesta = useCallback((b) => {
        if (!b) return null;
        const revMapTenencia = { 0: 'propia', 1: 'cedida', 2: 'alquilada' };
        const revMapEstado = { 0: 'Bueno', 1: 'Regular', 2: 'Malo' };
        let criticidad = '';
        if (b.precaria_casilla) criticidad = 'Precaria/Casilla';
        else if (b.proceso_consolidacion) criticidad = 'En proceso de consolidación';
        else if (b.consolidada) criticidad = 'Consolidada';
        return {
            nombreApellido: b.nombre_beneficiario || '',
            fechaNacimiento: b.fecha_nacimiento ? String(b.fecha_nacimiento).substring(0, 10) : '',
            dni: b.documento || '',
            telefono: b.telefono || '',
            direccion: b.direccion || '',
            barrio: b.barrio || '',
            localidad: b.localidad || '',
            personasACargo: b.personas_a_cargo != null ? String(b.personas_a_cargo) : '',
            aniosEnBarrio: b.anios_en_barrio != null ? String(b.anios_en_barrio) : '',
            tipoVivienda: revMapTenencia[b.tenencia_vivienda] || '',
            convivientes: b.grupo_familiar && b.grupo_familiar.length > 0
                ? b.grupo_familiar
                : [{ nombre: '', relacion: '', edad: '', estudia: '', trabaja: '' }],
            nivelCriticidad: criticidad,
            estadoGeneral: revMapEstado[b.estado_general] || '',
            breveDescripcionMejora: b.descripcion || '',
            prioridades: {
                piso: !!b.prioridad_piso, techo: !!b.prioridad_techo, paredes: !!b.prioridad_paredes,
                revoques: !!b.prioridad_revoque, aislante: !!b.prioridad_aislante,
                instalacionGas: !!b.instalaciones_gas, instalacionAgua: !!b.instalaciones_agua,
                instalacionLuz: !!b.instalaciones_luz, instalacionCloacas: !!b.instalaciones_cloacas,
                otros: !!b.prioridad_otro,
            },
            calidadDeVidaMejora: b.mejora_calidad_vida || '',
            materiales: b.mejoras && b.mejoras.length > 0
                ? b.mejoras
                : [{ descripcion: '', cantidad: '', precio: '' },
                { descripcion: '', cantidad: '', precio: '' },
                { descripcion: '', cantidad: '', precio: '' }],
            manoDeObraPrecio: b.mano_obra != null ? String(b.mano_obra) : '',
            otroGastoPrecio: b.otro != null ? String(b.otro) : '',
            montoCredito: b.monto_a_solicitar != null ? String(b.monto_a_solicitar) : (b.monto || ''),
            formaPago: '',
            nroCuotas: b.cantidad_cuotas != null ? String(b.cantidad_cuotas) : '',
            montoCuotas: b.monto_cuotas != null ? String(b.monto_cuotas) : '',
            mesInicio: b.mes_inicio != null ? String(b.mes_inicio) : '',
            frecuenciaPago: b.frecuencia_pago != null ? String(b.frecuencia_pago) : '',
            garantiaGarantes: b.garantia_garantes || '',
        };
    }, []);

    const handleGuardarEncuesta = useCallback((formData) => {
        const mapTenencia = { propia: 0, cedida: 1, alquilada: 2 };
        const mapEstadoGeneral = { Bueno: 0, Regular: 1, Malo: 2 };
        const existing = beneficiarioEditando;
        if (!existing) return;
        const actualizados = (Array.isArray(formA?.arrayBeneficiarios) ? formA.arrayBeneficiarios : []).map(b => {
            if (b.id !== existing.id) return b;
            return {
                ...b,
                _isNew: true,
                nombre_beneficiario: formData.nombreApellido.trim(),
                documento: formData.dni.trim(),
                direccion: formData.direccion.trim(),
                telefono: formData.telefono.trim(),
                monto: formData.montoCredito || '',
                fecha_nacimiento: formData.fechaNacimiento || null,
                barrio: formData.barrio || '',
                localidad: formData.localidad || '',
                personas_a_cargo: formData.personasACargo ? parseInt(formData.personasACargo) : null,
                anios_en_barrio: formData.aniosEnBarrio ? parseInt(formData.aniosEnBarrio) : null,
                tenencia_vivienda: mapTenencia[formData.tipoVivienda] ?? null,
                grupo_familiar: formData.convivientes || [],
                precaria_casilla: formData.nivelCriticidad === 'Precaria/Casilla',
                proceso_consolidacion: formData.nivelCriticidad === 'En proceso de consolidación',
                consolidada: formData.nivelCriticidad === 'Consolidada',
                estado_general: mapEstadoGeneral[formData.estadoGeneral] ?? null,
                descripcion: formData.breveDescripcionMejora || '',
                prioridad_piso: formData.prioridades.piso,
                prioridad_techo: formData.prioridades.techo,
                prioridad_paredes: formData.prioridades.paredes,
                prioridad_revoque: formData.prioridades.revoques,
                prioridad_aislante: formData.prioridades.aislante,
                prioridad_otro: formData.prioridades.otros ? 'Otros' : null,
                instalaciones_gas: formData.prioridades.instalacionGas,
                instalaciones_agua: formData.prioridades.instalacionAgua,
                instalaciones_luz: formData.prioridades.instalacionLuz,
                instalaciones_cloacas: formData.prioridades.instalacionCloacas,
                mejora_calidad_vida: formData.calidadDeVidaMejora || '',
                mejoras: formData.materiales || [],
                mano_obra: formData.manoDeObraPrecio ? parseFloat(formData.manoDeObraPrecio) : null,
                otro: formData.otroGastoPrecio ? parseFloat(formData.otroGastoPrecio) : null,
                monto_a_solicitar: formData.montoCredito ? parseFloat(formData.montoCredito) : null,
                cantidad_cuotas: formData.nroCuotas ? parseInt(formData.nroCuotas) : null,
                monto_cuotas: formData.montoCuotas ? parseFloat(formData.montoCuotas) : null,
                mes_inicio: formData.mesInicio ? parseInt(formData.mesInicio) : null,
                frecuencia_pago: formData.frecuenciaPago ? parseInt(formData.frecuenciaPago) : null,
                garantia_garantes: formData.garantiaGarantes || '',
            };
        });
        updateField('formA', 'arrayBeneficiarios', null, actualizados);
        setBeneficiarioEditando(null);
    }, [beneficiarioEditando, formA?.arrayBeneficiarios, updateField]);

    // Función para calcular avance acumulado desde mediciones
    const calcularAvanceAcumulado = () => {
        if (!arrayMediciones || arrayMediciones.length === 0) return 0;
        const ultima = arrayMediciones[arrayMediciones.length - 1];
        return parseFloat(ultima.porcentaje_avance) || 0;
    };



    return (
        <div className="p-6 border rounded-lg shadow-md">
            <div className="flex flex-row">

                {/*si es area de obras ----> h2 ---> SEGUIMIENTO DE OBRA*/}
                {/*para el resto de areas---> h2 ---> SEGUIMIENTO y las opciones de */}

                {areaResponsable === "ÁREA DE OBRAS" || areaResponsable === "ÁREA DE PROYECTOS" ? (
                    <h2 className="text-xl font-bold dark:text-white mb-2">SEGUIMIENTO DE OBRA</h2>
                ) : (
                    <h2 className="text-xl font-bold dark:text-white mb-2">SEGUIMIENTO</h2>
                )}
                <InfoButtonWithPopover infoText="EN ETAPA DE TESTEO: Comunicar al administrador cualquier inconveniente." />
            </div>
            {/* Encargado + Fechas */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                <div className="md:col-span-2">
                    <Label htmlFor="encargado_seguimiento">Encargado de seguimiento</Label>
                    <Select_simple
                        value={encargadoSeguimiento}
                        onChange={(e) => setEncargadoSeguimientoValue(e.target.value)}
                        options={opcionesEncargadoSeguimiento}
                        placeholder="Seleccionar..."
                    />
                </div>
                <div>
                    <Label htmlFor="fecha_inicio_obra">Fecha inicio obra</Label>
                    <DatePicker
                        selected={fechaInicioObra}
                        onChange={(date) => setFechaInicioObraValue(date)}
                        dateFormat="dd/MM/yyyy"
                        className="w-full p-2 border rounded"
                        placeholderText="DD/MM/AAAA"
                    />
                </div>
                <div>
                    <Label htmlFor="fecha_fin_obra">Fecha fin obra</Label>
                    <DatePicker
                        selected={fechaFinObra}
                        onChange={(date) => setFechaFinObraValue(date)}
                        dateFormat="dd/MM/yyyy"
                        className="w-full p-2 border rounded"
                        placeholderText="DD/MM/AAAA"
                    />
                </div>
            </div>
            {/* Montos */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                <div>
                    <Label htmlFor="monto_obraC">Monto conveniado</Label>
                    <div className="mt-1">
                        <input
                            type="text"
                            value={`$${Number(datosGenerales.monto_obra || 0).toLocaleString('es-AR')}`}
                            readOnly
                            className="w-full p-2 border rounded bg-gray-100"
                        />
                    </div>
                </div>

                {areaResponsable === 'ÁREA DE MICROCRÉDITOS' ? (
                    <div>
                        <Label htmlFor="porcentaje_gastos_operativos">% Gastos operativos</Label>
                        <input
                            id="porcentaje_gastos_operativos"
                            type="number"
                            min="0"
                            max="25"
                            placeholder="0"
                            value={formC?.porcentaje_gastos_operativos ?? ''}
                            onChange={(e) => {
                                const raw = e.target.value;
                                if (raw === '') { updateField('formC', 'porcentaje_gastos_operativos', null, ''); return; }
                                const num = parseInt(raw, 10);
                                if (isNaN(num)) return;
                                updateField('formC', 'porcentaje_gastos_operativos', null, String(Math.min(25, num)));
                            }}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                ) : (
                    [0, 1].map(i => {
                        const adendas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda');
                        const adenda = adendas[i];
                        const existe = !!adenda;
                        return (
                            <div key={`adenda-${i}`}>
                                <Label htmlFor={`monto_adenda_${i + 1}`}>Monto adenda {i + 1}</Label>
                                <div className="mt-1">
                                    <input
                                        type="text"
                                        value={existe ? `$${Number(adenda.monto_adenda || 0).toLocaleString('es-AR')}` : ''}
                                        readOnly
                                        disabled={!existe}
                                        className={`w-full p-2 border rounded ${existe ? 'bg-gray-100' : 'bg-gray-200 text-gray-400'}`}
                                    />
                                </div>
                            </div>
                        );
                    })
                )}

                <div>
                    <Label htmlFor="monto_total">
                        {areaResponsable === 'ÁREA DE MICROCRÉDITOS' ? 'Monto total (conveniado - gastos op.)' : 'Monto total'}
                    </Label>
                    <div className="mt-1">
                        <input
                            type="text"
                            value={areaResponsable === 'ÁREA DE MICROCRÉDITOS'
                                ? `$${Math.max(0, Number(datosGenerales.monto_obra || 0) * (1 - (Number(formC?.porcentaje_gastos_operativos) || 0) / 100)).toLocaleString('es-AR')}`
                                : `$${(Number(datosGenerales.monto_obra || 0) + Number(totalAdenda || 0)).toLocaleString('es-AR')}`}
                            readOnly
                            className="w-full p-2 border rounded bg-green-50 font-semibold text-green-700"
                        />
                    </div>
                </div>
            </div>

            {/* Tabla de Mediciones de Obra o Tabla de Mejoras Etapa I en función de las reglas del área */}
            {(areaResponsable === "ÁREA DE PROYECTOS" || areaResponsable === "OBRAS" || areaResponsable === "ÁREA DE OBRAS") ? (
                <TablaMediciones
                    mediciones={arrayMediciones}
                    onMedicionesChange={handleMedicionesChange}
                    avanceAcumulado={calcularAvanceAcumulado()}
                    pagosProyectos={formC?.arrayPagosProyectos || []}
                    porcentajeParcial2doPago={porcentajeParcial2doPago}
                    porcentajeParcial3erPago={porcentajeParcial3erPago}
                    esRoleSeguimiento={role === 'seguimiento'}
                />
            ) : (areaResponsable === "ÁREA DE MEJORAS" && datosGenerales.modalidad === "etapa I") ? (
                <TablaMejorasEtapaI
                    mejorasEtapaI={arrayMejorasEtapaI}
                    onMejorasChange={handleMejorasEtapaIChange}
                    codigoObra={datosGenerales.id_partido_obra}
                    etapa="i"
                />
            ) : (areaResponsable === "ÁREA DE MEJORAS" && datosGenerales.modalidad === "etapa II") ? (
                <TablaMejorasEtapaI
                    mejorasEtapaI={arrayMejorasEtapaII}
                    onMejorasChange={handleMejorasEtapaIIChange}
                    codigoObra={datosGenerales.id_partido_obra}
                    etapa="ii"
                    titulo="Seguimiento de Intercambios (Mejoras - Etapa II)"
                    tooltip="Registro dinámico de intercambios. Permite documentar cada fecha, el N° de PV, la descripción del intercambio y el estado (Enviado / Recibido / Sin estado) para el seguimiento de la Etapa II."
                />
            ) : (areaResponsable === "ÁREA DE MICROCRÉDITOS") ? (
                <div className="space-y-6">
                    {/* Circuito administrativo */}
                    <div className="border rounded-lg p-4 bg-white dark:bg-gray-800">
                        <button
                            onClick={() => setCircuitoAdminOpen(!circuitoAdminOpen)}
                            className="flex items-center justify-between w-full text-left"
                            type="button"
                        >
                            <h3 className="text-lg font-semibold dark:text-white">Circuito administrativo</h3>
                            <svg className={`w-5 h-5 transition-transform ${circuitoAdminOpen ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                            </svg>
                        </button>
                        {circuitoAdminOpen && (
                            <CircuitoAdministrativo
                                datos={arrayCircuitoAdmin}
                                onChange={handleCircuitoAdminChange}
                                disabled={circuitoAdminDisabled}
                            />
                        )}
                        {circuitoAdminDisabled && (
                            <span className="block text-sm text-red-600 dark:text-red-400 mt-2 ml-2">
                                * Solo se puede editar el circuito administrativo en estado "En circuito administrativo".
                            </span>
                        )}
                    </div>

                    {/* Modal PDF de No Objeción */}
                    {beneficiarioPDF && (
                        <NoObjecionPDF
                            beneficiary={beneficiarioPDF}
                            obraData={{ datosGenerales, array_obras_expediente }}
                            onClose={() => setBeneficiarioPDF(null)}
                        />
                    )}

                    {/* Beneficiarios */}
                    <div className="border rounded-lg p-4 bg-white dark:bg-gray-800">
                        <button
                            onClick={() => setBeneficiariosOpen(!beneficiariosOpen)}
                            className="flex items-center justify-between w-full text-left mb-3"
                            type="button"
                        >
                            <h3 className="text-lg font-semibold dark:text-white">Beneficiarios <span className="text-sm font-normal text-gray-400">({(Array.isArray(formA?.arrayBeneficiarios) ? formA.arrayBeneficiarios : []).length})</span></h3>
                            <svg className={`w-5 h-5 transition-transform ${beneficiariosOpen ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                            </svg>
                        </button>
                        {beneficiariosOpen && (
                        <>
                        <div className="flex items-center justify-end">
                            <div className="flex items-center gap-3">
                                <label className="flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-400 cursor-pointer select-none">
                                    <input
                                        type="checkbox"
                                        checked={showBarrioColumns}
                                        onChange={(e) => setShowBarrioColumns(e.target.checked)}
                                        className="h-3.5 w-3.5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                    />
                                    Barrio RENABAP / RPPVAP / Otro
                                </label>
                                {datosGenerales.estado === 'Seguimiento' && (
                                    <button
                                        onClick={handleAgregarBeneficiario}
                                        className="text-sm bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 rounded font-medium"
                                    >
                                        + Añadir beneficiario
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                <thead className="bg-gray-50 dark:bg-gray-700">
                                    <tr>
                                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase w-10">#</th>
                                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Nombre</th>
                                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">DNI</th>
                                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Monto</th>
                                        {showBarrioColumns && (
                                            <>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Barrio RENABAP</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Barrio RPPVAP</th>
                                                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Otro</th>
                                            </>
                                        )}
                                        {datosGenerales.estado === 'Seguimiento' && (
                                            <>
                                                <th className="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase w-20">Pendiente</th>
                                                <th className="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase w-48">Acciones</th>
                                            </>
                                        )}
                                    </tr>
                                </thead>
                                <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                    {(Array.isArray(formA?.arrayBeneficiarios) ? formA.arrayBeneficiarios : []).length === 0 ? (
                                        <tr>
                                            <td colSpan={4 + (showBarrioColumns ? 3 : 0) + (datosGenerales.estado === 'Seguimiento' ? 2 : 0)} className="px-4 py-6 text-center text-gray-400">
                                                No hay beneficiarios cargados
                                            </td>
                                        </tr>
                                    ) : (
                                        (() => {
                                            const items = Array.isArray(formA?.arrayBeneficiarios) ? formA.arrayBeneficiarios : [];
                                            const nuevos = items.filter(esNuevoBeneficiario);
                                            const existentes = items.filter(b => !esNuevoBeneficiario(b)).sort((a, b) => {
                                                const na = a.nro_beneficiario, nb = b.nro_beneficiario;
                                                const numA = na != null && na !== '' ? Number(na) : NaN;
                                                const numB = nb != null && nb !== '' ? Number(nb) : NaN;
                                                if (!isNaN(numA) && isNaN(numB)) return -1;
                                                if (isNaN(numA) && !isNaN(numB)) return 1;
                                                if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
                                                return 0;
                                            });
                                            const renderRow = (item, index) => (
                                                <tr key={item.id || index} className={`hover:bg-gray-50 dark:hover:bg-gray-700 ${esNuevoBeneficiario(item) ? 'bg-yellow-50 dark:bg-yellow-900/10' : ''}`}>
                                                    <td className="px-4 py-2 text-gray-400 text-xs font-mono">{item.nro_beneficiario ?? '-'}</td>
                                                    <td className="px-4 py-2 font-medium">{item.nombre_beneficiario}</td>
                                                    <td className="px-4 py-2">{item.documento || '-'}</td>
                                                    <td className="px-4 py-2">{item.monto ? `$${Number(item.monto).toLocaleString('es-AR')}` : '-'}</td>
                                                    {showBarrioColumns && (
                                                        <>
                                                            <td className="px-4 py-2 text-xs">{beneficiarioBarrios.get(item.id)?.renabap || '-'}</td>
                                                            <td className="px-4 py-2 text-xs">{beneficiarioBarrios.get(item.id)?.rppvap || '-'}</td>
                                                            <td className="px-4 py-2 text-xs">{beneficiarioBarrios.get(item.id)?.otro || '-'}</td>
                                                        </>
                                                    )}
                                                    {datosGenerales.estado === 'Seguimiento' && (
                                                        <>
                                                            <td className="px-4 py-2 text-center">
                                                                {esNuevoBeneficiario(item) ? (
                                                                    <span className="inline-block text-yellow-700 bg-yellow-100 dark:bg-yellow-800 dark:text-yellow-200 text-[10px] font-bold px-2 py-0.5 rounded">PENDIENTE</span>
                                                                ) : (
                                                                    <span className="text-green-600 text-xs font-medium">✓</span>
                                                                )}
                                                            </td>
                                                            <td className="px-4 py-2 text-center whitespace-nowrap">
                                                                <button
                                                                    onClick={() => handleEditarEncuesta(item)}
                                                                    className="text-blue-600 hover:text-blue-800 text-xs mr-1 px-2 py-1 border border-blue-300 rounded inline-block"
                                                                    title="Editar datos de la encuesta"
                                                                >
                                                                    Editar
                                                                </button>
                                                                <button
                                                                    onClick={() => handleEditarGeo(item)}
                                                                    className="text-purple-600 hover:text-purple-800 text-xs mr-1 px-2 py-1 border border-purple-300 rounded inline-block"
                                                                    title={item.wkt ? 'Editar ubicación en el mapa' : 'Agregar ubicación en el mapa'}
                                                                >
                                                                    {item.wkt ? 'Editar geo' : 'Agregar geo'}
                                                                </button>
                                                                <button
                                                                    onClick={() => handleEliminarBeneficiario(item.id)}
                                                                    className="text-red-600 hover:text-red-800 text-xs mr-1 px-2 py-1 border border-red-300 rounded inline-block"
                                                                    title="Eliminar beneficiario"
                                                                >
                                                                    Borrar
                                                                </button>
                                                                <button
                                                                    onClick={() => setBeneficiarioPDF(item)}
                                                                    className="text-green-600 hover:text-green-800 text-xs px-2 py-1 border border-green-300 rounded inline-block"
                                                                    title="PDF de No Objeción"
                                                                >
                                                                    PDF
                                                                </button>
                                                            </td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                            return (
                                                <>
                                                    {nuevos.length > 0 && (
                                                        <>
                                                            <tr className="bg-yellow-100 dark:bg-yellow-900/20">
                                                                <td colSpan={4 + (showBarrioColumns ? 3 : 0) + (datosGenerales.estado === 'Seguimiento' ? 2 : 0)} className="px-4 py-1.5 text-xs font-semibold text-yellow-700 dark:text-yellow-300 uppercase tracking-wider">
                                                                    Pendientes
                                                                </td>
                                                            </tr>
                                                            {nuevos.map((item, i) => renderRow(item, i))}
                                                            <tr className="h-2" />
                                                        </>
                                                    )}
                                                    {existentes.length > 0 && (
                                                        <>
                                                            <tr className="bg-gray-100 dark:bg-gray-700">
                                                                <td colSpan={4 + (showBarrioColumns ? 3 : 0) + (datosGenerales.estado === 'Seguimiento' ? 2 : 0)} className="px-4 py-1.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                                                    Guardados
                                                                </td>
                                                            </tr>
                                                            {existentes.map((item, i) => renderRow(item, i))}
                                                        </>
                                                    )}
                                                </>
                                            );
                                        })()
                                    )}
                                </tbody>
                            </table>
                        </div>
                        </>
                    )}
                    </div>

                    {datosGenerales.estado === 'Seguimiento' && (
                        <Modal2
                            partido={datosGenerales?.partido}
                            areaResponsable={areaResponsable}
                            beneficiarios={Array.isArray(formA?.arrayBeneficiarios) ? formA.arrayBeneficiarios : []}
                            onBeneficiariosChange={handleBeneficiariosChange}
                            isOpen={modal2Abierto}
                            onClose={handleCerrarModal2}
                            geoEditBeneficiario={beneficiarioGeoEditando}
                            editBeneficiario={beneficiarioEditandoModal}
                            showButton={false}
                            renabapIds={(formA?.barriosRENABAPSeleccionados || []).map(b => b.value).filter(Boolean).join(',')}
                            rppvapCodigos={(formA?.barriosSeleccionados || []).map(b => b.value).filter(Boolean).join(',')}
                            onAddTarget={handleAddTarget}
                            onRemoveTarget={handleRemoveTarget}
                            onSetOtroTipo={handleSetOtroTipo}
                            onSetOtroNombre={handleSetOtroNombre}
                            onRemoveOtroTipo={handleRemoveOtroTipo}
                            idTablaObras={datosGenerales?.id}
                            cg01IdPartidoObra={datosGenerales?.cg_01_id_partido_obra || datosGenerales?.partido}
                        />
                    )}
                </div>
            ) : null}

            {/* Componente de pagos - usa el contexto internamente */}
            <PagosFormulario />

            {/* Observaciones */}
            <div className="mt-4">
                <Label htmlFor="observ_seguimiento_obra">Observaciones del Seguimiento de Obra</Label>
                <textarea
                    id="observ_seguimiento_obra"
                    name="observ_seguimiento_obra"
                    value={observaciones}
                    placeholder="Ingrese observaciones del seguimiento de obra"
                    maxLength="5000"
                    onChange={(e) => setObservacionesValue(e.target.value)}
                    className={`w-full px-4 py-2 text-sm border rounded-md focus:outline-none resize-y ${(observaciones?.length || 0) >= 5000
                        ? 'border-red-500 focus:border-red-500 bg-red-50 dark:bg-red-900/20'
                        : (observaciones?.length || 0) >= 4000
                            ? 'border-yellow-400 focus:border-yellow-400 bg-yellow-50 dark:bg-yellow-900/20'
                            : 'border-gray-300 focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700'
                        }`}
                    rows="4"
                />
                <div className="mt-1">
                    <p align="right" className={`text-sm ${(observaciones?.length || 0) >= 5000
                        ? 'text-red-600 font-semibold'
                        : (observaciones?.length || 0) >= 4000
                            ? 'text-yellow-600'
                            : 'text-gray-500'
                        }`} style={{ fontSize: "0.85em" }}>
                        {observaciones?.length || 0}/5000 caracteres
                        {(observaciones?.length || 0) >= 5000 && ' (límite alcanzado)'}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FormC_SeguimientoObra;
